export default "__VITE_ASSET__CeYjWpVs__"